import { PageHeader } from '@/components/PageHeader';
import { QueryState } from '@/components/QueryState';
import { SubcontractBadge } from '@/components/StatusBadge';
import { isoDate, millionWon, won } from '@/lib/format';
import { useSubcontracts } from '@/lib/queries';
import { useSite } from '@/lib/useSite';
import { ContractSigningSection } from '@/pages/contract/ContractSigningSection';

/**
 * 내 계약.
 *
 * <p>보여 주는 것은 <b>내 업체의 하도급 계약</b>뿐이다(`pmis_subcontracts`). 도급계약(발주처와
 * 본사 사이)은 남의 계약이라 여기 오지 않는다 — 서버가 `vendor_id` 로 잘라서 준다.
 */
export function ContractPage() {
  const { siteId, siteName } = useSite();
  const contracts = useSubcontracts(siteId);
  const rows = contracts.data ?? [];

  return (
    <>
      <PageHeader title="계약" subtitle={siteName} />
      <ContractSigningSection siteId={siteId} />
      <QueryState
        pending={contracts.isPending}
        error={contracts.isError}
        empty={rows.length === 0}
        emptyText="등록된 계약이 없습니다."
      >
        <ul className="flex flex-col gap-2">
          {rows.map((row) => (
            <li key={row.id} className="card">
              <div className="mb-2 flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="truncate text-ui-md font-medium">{row.workName}</div>
                  <div className="text-ui-2xs" style={{ color: 'var(--text-muted)' }}>
                    {row.trade}
                    {row.contractNo !== null && ` · ${row.contractNo}`}
                  </div>
                </div>
                <SubcontractBadge status={row.status} />
              </div>

              <dl className="flex flex-col gap-1 text-ui-xs">
                <div className="flex justify-between gap-3">
                  <dt style={{ color: 'var(--text-secondary)' }}>계약금액 (VAT 포함)</dt>
                  <dd className="text-right font-medium">{won(row.amountWithVat)}</dd>
                </div>
                <div className="flex justify-between gap-3">
                  <dt style={{ color: 'var(--text-secondary)' }}>공급가액</dt>
                  <dd className="text-right">{millionWon(row.amountWithoutVat)}</dd>
                </div>
                <div className="flex justify-between gap-3">
                  <dt style={{ color: 'var(--text-secondary)' }}>공사기간</dt>
                  <dd className="text-right">
                    {isoDate(row.startDate)} ~ {isoDate(row.endDate)}
                  </dd>
                </div>
              </dl>
            </li>
          ))}
        </ul>
      </QueryState>
    </>
  );
}
